import { Tag } from 'antd';

// Tag de status (rascunho / ativa / arquivada).
export default function StatusBadge({ status }: { status: string }) {
  const colors: Record<string, string> = { rascunho: 'gold', ativa: 'green', arquivada: 'default' };
  const labels: Record<string, string> = { rascunho: 'Rascunho', ativa: 'Ativa', arquivada: 'Arquivada' };
  return <Tag color={colors[status] || 'default'}>{labels[status] || status}</Tag>;
}
